import React, { FC, useState, useMemo, useCallback } from "react";
import { AccordionContext, useAccordion, useAccordionContext } from "./hooks/useAccordion";
import { StyledAccordion } from "./styled";
import { AccordionItem, AccordionTitle } from "./components";
import { useKeyboardNavigation } from "./hooks/useKeyboardNavigation";

interface Props {
  spacing?: string;
}

const Accordion: FC<React.PropsWithChildren<Props>> = ({ children, spacing }) => {
  const [activeId, setActiveId] = useState("");

  const { focusedNodeId, onKeyDown } = useKeyboardNavigation(children);

  const onAccordionClick = useCallback(
    (id: string) => {
      const nextId = activeId === id ? "" : id;
      focusedNodeId.current = nextId;
      setActiveId(nextId);
    },
    [activeId, focusedNodeId],
  );

  const context = useMemo(
    () => ({
      activeId,
      onAccordionClick,
    }),
    [activeId, onAccordionClick],
  );

  return (
    <AccordionContext.Provider value={context}>
      <StyledAccordion onKeyDown={onKeyDown}>{children}</StyledAccordion>
    </AccordionContext.Provider>
  );
};

export { Accordion, AccordionItem, AccordionTitle, useAccordion, useAccordionContext };
